import { createIcon } from "../../../packages/excalidraw/components/icons";

// Tabler "plug-connected": the one mark for everything agent-related (menu
// item, welcome shortcut, toolbar item, drawer and page headers).
export const plugIcon = createIcon(
  <g strokeWidth="1.5">
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z" />
    <path d="M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z" />
    <path d="M3 21l2.5 -2.5" />
    <path d="M18.5 5.5l2.5 -2.5" />
    <path d="M10 11l-2 2" />
    <path d="M13 14l-2 2" />
  </g>,
  { width: 24, height: 24, fill: "none", stroke: "currentColor" },
);
